import { type MutationTree } from 'vuex';

import { type IPrivateContactCompanyState } from './types';

export const RECEIVE_BY_CONTACT = 'receiveByContact';

export const mutations: MutationTree<IPrivateContactCompanyState> = {
    [RECEIVE_BY_CONTACT](_state: IPrivateContactCompanyState, { contactId, idList }: { contactId: number; idList: number[] }) {
        _state.byContact.set(contactId, idList);
    }
};
